import React from 'react';
import { Row, Col } from 'reactstrap';
import { FilterElement } from "./FilterElement";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import {
  TRANSLATED_CERTIFICATE_STATUSES,
  TRANSLATED_PACKAGE_STATUSES,
  TRANSLATED_TICKETS_STATUSES
} from "../../../config/constants";

const FiltersList = ({ filters, onRemoveFilter, onRemoveAllFilters, filterList }) => {
  let hasActiveFilters = false;

  Object.keys( filters ).forEach( function (key) {
    if (Array.isArray( filters[key] ))
      if (filters[key].length > 0) {
        hasActiveFilters = true;
      }
  } );

  if (! hasActiveFilters) {
    return null;
  }

  const getTranslatedFilterList = () => {
    switch (filterList) {
      case 'documents': {
        return TRANSLATED_PACKAGE_STATUSES;
      }
      case 'tickets':{
        return TRANSLATED_TICKETS_STATUSES
      }
      case 'certificates':{
        return TRANSLATED_CERTIFICATE_STATUSES
      }
      default: {
        return TRANSLATED_PACKAGE_STATUSES;
      }
    }
  }

  return (
    <Row>
      <Col>
        <FormattedMessage id="app.active.filters"/>
        {
          Object.keys( filters ).map( (item) => {
            if (! Array.isArray( filters[item] )) return null;

            return filters[item]?.map( (elem, j) => {

              elem.title = getTranslatedFilterList()[elem.identifier]

              if (elem.customTitle) {
                elem.title = elem.customTitle;
              }

              return (
                <FilterElement
                  key={j}
                  item={elem}
                  onRemoveFilter={onRemoveFilter}
                />
              )
            } );
          } )
        }
        <Link
          to="#"
          className="cursor-pointer ml-2 link-icon-color"
          id={`clear-all`}
          onClick={e => {
            e.preventDefault();
            onRemoveAllFilters()
          }}
        >
          <FormattedMessage id="button.clear.all"/>
        </Link>
      </Col>
    </Row>
  );
}

export { FiltersList };
